
(() => {
  if (window.MaraBFCountdown) {
    window.MaraBFCountdown.init();
    return;
  }

  const timers = new Map();

  const format = (value) => String(value).padStart(2, "0");

  const initialize = (element) => {
    if (timers.has(element)) return;

    const target = Date.parse(element.dataset.target || "");

    if (!Number.isFinite(target)) {
      console.warn("MARA BF Countdown: Invalid target date");
      return;
    }

    const days = element.querySelector('[data-unit="days"]');
    const hours = element.querySelector('[data-unit="hours"]');
    const minutes = element.querySelector('[data-unit="minutes"]');
    const seconds = element.querySelector('[data-unit="seconds"]');

    if (!days || !hours || !minutes || !seconds) return;

    const update = () => {
      const remaining = Math.max(
        0,
        Math.floor((target - Date.now()) / 1000)
      );

      days.textContent = format(Math.floor(remaining / 86400));
      hours.textContent = format(Math.floor(remaining / 3600) % 24);
      minutes.textContent = format(Math.floor(remaining / 60) % 60);
      seconds.textContent = format(remaining % 60);

      if (remaining === 0) {
        clearInterval(timers.get(element));
        timers.delete(element);
      }
    };

    update();

    if (target > Date.now()) {
      const timer = window.setInterval(update, 1000);
      timers.set(element, timer);
    }
  };

  const init = (root = document) => {
    root.querySelectorAll("[data-bf-countdown]").forEach(initialize);
  };

  const cleanup = (root) => {
    root.querySelectorAll("[data-bf-countdown]").forEach((element) => {
      if (timers.has(element)) {
        clearInterval(timers.get(element));
        timers.delete(element);
      }
    });
  };

  window.MaraBFCountdown = { init };

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", () => init(), {
      once: true
    });
  } else {
    init();
  }

  document.addEventListener("shopify:section:load", (event) => {
    init(event.target);
  });

  document.addEventListener("shopify:section:unload", (event) => {
    cleanup(event.target);
  });
})();
